export const errorText = Object.freeze({
  canceledByFetchingNewData: 'Request canceled by fetching new data',
  canceledByUser: 'Request canceled by the user',
  canceledByUnmountComponent: 'Request canceled by the Unmount Component function',
});
